import { mix, setLightness, transparentize } from "polished";

export const brandGreen = "#4FB948";
export const brandOrange = "#F8981D";
export const brandBlue = "#005695";
export const brandRed = "#D22630";

export const green = brandGreen;
export const orange = brandOrange;
export const blue = brandBlue;
export const red = brandRed;
export const black = "#000";
export const white = "#fff";
export const yellow = "#F8E01D";

const makeTransparent = transparentize(0.25);

export const greenTransparent = makeTransparent(green);
export const orangeTransparent = makeTransparent(orange);
export const blueTransparent = makeTransparent(blue);
export const whiteTransparent = makeTransparent(white);
export const redTransparent = makeTransparent(red);

export const link = blue;

export const darkText = "#666";
export const grayText = "#808080";
export const darkHeadlineText = black;

export const muted = "#999";
export const placeholder = "#747474";

export const divider = "#CCC";

export const background = "#F2F2F2";
export const insetBackground = "#f7f7f7";

export const hover = insetBackground;

export const selected = background;

export const alert = "#EE3524";
export const success = green;

export const lightGreen = setLightness(0.9, green);
export const lightBlue = setLightness(0.9, blue);
export const lightOrange = setLightness(0.9, orange);
export const lightRed = setLightness(0.9, red);

export const greenLight = lightGreen;
export const blueLight = lightBlue;
export const orangeLight = lightOrange;
export const redLight = lightRed;

const makeAlt = color => mix(0.9, white, color);

export const greenAlt = makeAlt(green);
export const orangeAlt = makeAlt(orange);
export const blueAlt = makeAlt(blue);
export const redAlt = makeAlt(red);

export const greenHover = setLightness(0.6, green);
export const blueHover = setLightness(0.6, blue);
export const orangeHover = setLightness(0.6, orange);
export const redHover = setLightness(0.6, red);

export const orangeBorder = setLightness(0.8, orange);

export const tableBorder = "#eee";
export const tableBorderDark = "#ddd";
export const tableAltRow = "#f3f3f3";

export const cardEdge = "#f7f7f7";
export const midGray = "#656565";
export const darkGray = "#474747";



// WEBPACK FOOTER //
// ./src/styles/colors.js